var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrowIconTransparent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20872 0.259408L3.81988 3.32781L4.50785 4.0491L5.19762 3.32784L7.80699 0.259438C7.97508 0.0622578 8.2263 -0.0217214 8.46611 0.0390911C8.70604 0.0999141 8.89802 0.296293 8.96999 0.554282C9.04183 0.812265 8.9826 1.09264 8.81464 1.28982L5.01161 5.76004C4.88138 5.91313 4.69887 6 4.50785 6C4.31682 6 4.13432 5.91313 4.00409 5.76004L0.202891 1.28982C0.0703739 1.14529 -0.00291474 0.947831 8.88161e-05 0.743018C0.00297377 0.538195 0.0817996 0.343384 0.218389 0.203465C0.354979 0.0635452 0.537605 -0.00964069 0.724426 0.00102139C0.911244 0.0115514 1.08605 0.104878 1.20872 0.259408Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowIconTransparent);
export default __webpack_public_path__ + "static/media/down-arrow-icon-transparent.da10cbbb031f8ee20d4d236da0f2f00b.svg";
export { ForwardRef as ReactComponent };